import { PermissionsGroupName, PermissionsReportsFeatures } from '@/constants/permissions';
import {
  ACCOUNTING_REPORT_TABS,
  ADMIN_REPORT_TABS,
  EXPORT_REPORT_TABS,
  IMPORT_REPORT_TABS,
  IPI_REPORT_TABS,
} from '@/constants/reports';

export const reportsRoutes = [
  {
    name: 'Reports',
    path: 'reports',
    component: () => import('@/layouts/EmptyRouterView.vue'),
    redirect: { name: 'ReportsImports' },
    meta: {
      dynamicTitle: true,
      pageTitle: 'Reports',
      permission: PermissionsGroupName.REPORTS,
    },
    children: [
      {
        name: 'ReportsImports',
        path: 'import',
        meta: {
          dynamicTitle: true,
          pageTitle: 'Import Reports',
          permission: PermissionsReportsFeatures.IMPORT,
        },
        props: {
          tabs: IMPORT_REPORT_TABS,
        },
        component: () => import('@/views/reports/ReportsTemplateView.vue'),
      },
      {
        name: 'ReportsExports',
        path: 'export',
        meta: {
          dynamicTitle: true,
          pageTitle: 'Export Reports',
          permission: PermissionsReportsFeatures.EXPORT,
        },
        props: {
          tabs: EXPORT_REPORT_TABS,
        },
        component: () => import('@/views/reports/ReportsTemplateView.vue'),
      },
      {
        name: 'ReportsIPI',
        path: 'ipi',
        meta: {
          dynamicTitle: true,
          pageTitle: 'IPI Reports',
          permission: PermissionsReportsFeatures.IPI,
        },
        props: {
          tabs: IPI_REPORT_TABS,
        },
        component: () => import('@/views/reports/ReportsTemplateView.vue'),
      },
      {
        name: 'ReportsAccounting',
        path: 'accounting',
        meta: {
          dynamicTitle: true,
          pageTitle: 'Accounting Reports',
          permission: PermissionsReportsFeatures.ACCOUNTING,
        },
        props: {
          tabs: ACCOUNTING_REPORT_TABS,
        },
        component: () => import('@/views/reports/ReportsTemplateView.vue'),
      },
      {
        name: 'ReportsAdmin',
        path: 'admin',
        meta: {
          dynamicTitle: true,
          pageTitle: 'Admin Reports',
          permission: PermissionsReportsFeatures.ADMIN,
        },
        props: {
          tabs: ADMIN_REPORT_TABS,
        },
        component: () => import('@/views/reports/ReportsTemplateView.vue'),
      },
    ],
  },
];
